export const seniority = [
  { years: 0, perYear: 0, cumulative: 1, perLessOne: 0 },
  { years: 1, perYear: 2.5, cumulative: 1.025, perLessOne: 2.5 },
  { years: 2, perYear: 2.5, cumulative: 1.0506, perLessOne: 5.06 },
  { years: 3, perYear: 1.5, cumulative: 1.0664, perLessOne: 6.64 },
  { years: 4, perYear: 1.5, cumulative: 1.0824, perLessOne: 8.24 },
  { years: 5, perYear: 1.5, cumulative: 1.0986, perLessOne: 9.86 },
  { years: 6, perYear: 1.5, cumulative: 1.1151, perLessOne: 11.51 },
  { years: 7, perYear: 1.5, cumulative: 1.1318, perLessOne: 13.18 },
  { years: 8, perYear: 1.5, cumulative: 1.1488, perLessOne: 14.88 },
  { years: 9, perYear: 1.5, cumulative: 1.166, perLessOne: 16.6 },
  { years: 10, perYear: 1.5, cumulative: 1.1835, perLessOne: 18.35 },
  { years: 11, perYear: 1.5, cumulative: 1.2013, perLessOne: 20.13 },
  { years: 12, perYear: 1, cumulative: 1.2133, perLessOne: 21.33 },
  { years: 13, perYear: 1, cumulative: 1.2254, perLessOne: 22.54 },
  { years: 14, perYear: 1, cumulative: 1.2377, perLessOne: 23.77 },
  { years: 15, perYear: 1, cumulative: 1.2501, perLessOne: 25.01 },
  { years: 16, perYear: 1, cumulative: 1.2626, perLessOne: 26.26 },
  { years: 17, perYear: 1, cumulative: 1.2752, perLessOne: 27.52 },
  { years: 18, perYear: 1, cumulative: 1.2879, perLessOne: 28.79 },
  { years: 19, perYear: 1, cumulative: 1.3008, perLessOne: 30.08 },
  { years: 20, perYear: 1, cumulative: 1.3138, perLessOne: 31.38 },
  { years: 21, perYear: 1, cumulative: 1.327, perLessOne: 32.7 },
  { years: 22, perYear: 1, cumulative: 1.3402, perLessOne: 34.02 },
  { years: 23, perYear: 1, cumulative: 1.3536, perLessOne: 35.36 },
  { years: 24, perYear: 1, cumulative: 1.3672, perLessOne: 36.72 },
  { years: 25, perYear: 1, cumulative: 1.3808, perLessOne: 38.08 },
  { years: 26, perYear: 1, cumulative: 1.3946, perLessOne: 39.46 },
  { years: 27, perYear: 1, cumulative: 1.4086, perLessOne: 40.86 },
  { years: 28, perYear: 1, cumulative: 1.4227, perLessOne: 42.27 },
  { years: 29, perYear: 1, cumulative: 1.4369, perLessOne: 43.69 },
  { years: 30, perYear: 1, cumulative: 1.4513, perLessOne: 45.13 },
  { years: 31, perYear: 1, cumulative: 1.4658, perLessOne: 46.58 },
  { years: 32, perYear: 1, cumulative: 1.4804, perLessOne: 48.04 },
  { years: 33, perYear: 1, cumulative: 1.4952, perLessOne: 49.52 },
  { years: 34, perYear: 1, cumulative: 1.5102, perLessOne: 51.02 },
  { years: 35, perYear: 0.5, cumulative: 1.5177, perLessOne: 51.77 },
  { years: 36, perYear: 0.5, cumulative: 1.5253, perLessOne: 52.53 },
  { years: 37, perYear: 0.5, cumulative: 1.533, perLessOne: 53.3 },
  { years: 38, perYear: 0.5, cumulative: 1.5406, perLessOne: 54.06 },
  { years: 39, perYear: 0.5, cumulative: 1.5483, perLessOne: 54.83 },
  { years: 40, perYear: 0.5, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 41, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 42, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 43, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 44, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 45, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 46, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 47, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 48, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 49, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 50, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 51, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 52, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 53, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 54, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 55, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 56, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 57, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 58, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 59, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 60, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 61, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 62, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 63, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
  { years: 64, perYear: 0, cumulative: 1.5561, perLessOne: 55.61 },
];

export const salaryBase = 8000;
export const levelPerTime = [
  { level: 0, min: -1000, max: 3 },
  { level: 1, min: 3, max: 6 },
  { level: 2, min: 6, max: 11 },
  { level: 3, min: 11, max: 16 },
  { level: 4, min: 16, max: 10000 },
];
export const levelPerCompletion = [
  { level: 1, min: 0, max: 550 },
  { level: 2, min: 550, max: 1000 },
  { level: 3, min: 1000, max: 1500 },
  { level: 4, min: 1500, max: 1000000 },
];
export const hoursPerDegree = [
  { degree: "תואר שני", hours: 500 },
  { degree: "תואר ראשון", hours: 0 },
  { degree: 'ד"ר', hours: 700 },
];
export const addiitionToShekelLaw = [
  { level: 'לא עו"ס לחוק', increase: 0 },
  { level: 'עו"ס סדרי דין(חוק החוסים)', increase: 433 },
  { level: 'עו"ס בשירות מבחן', increase: 433 },
  { level: 'עו"ס חוק הסעד (מש"ה)', increase: 433 },
  { level: 'עו"ס ביחידות הסיוע', increase: 433 },
  { level: 'עו"ס חוק האימוץ', increase: 433 },
  { level: 'עו"ס מפקח/ת נפגעי עבירה', increase: 433 },
  { level: 'עו"ס לחוק הנוער', increase: 650 },
  { level: 'עו"ס סדרי דין', increase: 650 },
  { level: 'עו"ס מעצרים בשירות מבחן', increase: 650 },
  { level: 'עו"ס חוקר/ת ילדים', increase: 650 },
  { level: "מנהלים", increase: 270 },
];
export const managementLevels = [
  {
    level: "0",
    beginner: 1,
    advanced: 1.5,
    experienced: 2.5,
    senior: 4,
    seniorPlus: 5.5,
    specialist: 6.5,
  },
  {
    level: "1",
    beginner: 1.75,
    advanced: 2.25,
    experienced: 3.25,
    senior: 4.75,
    seniorPlus: 6.25,
    specialist: 7.25,
  },
  {
    level: "2",
    beginner: 2.5,
    advanced: 3,
    experienced: 4,
    senior: 5.5,
    seniorPlus: 7,
    specialist: 8,
  },
  {
    level: "3",
    beginner: 4,
    advanced: 4.5,
    experienced: 5.5,
    senior: 7,
    seniorPlus: 8.5,
    specialist: 9.5,
  },
  {
    level: "4",
    beginner: 5.5,
    advanced: 6,
    experienced: 7,
    senior: 8.5,
    seniorPlus: 10,
    specialist: 11,
  },
  {
    level: "5",
    beginner: 7,
    advanced: 7.5,
    experienced: 8.5,
    senior: 10,
    seniorPlus: 11.5,
    specialist: 12.5,
  },
  {
    level: "6",
    beginner: 8.5,
    advanced: 9,
    experienced: 10,
    senior: 11.5,
    seniorPlus: 13,
    specialist: 14,
  },
  {
    level: "7",
    beginner: 10,
    advanced: 10.5,
    experienced: 11.5,
    senior: 13,
    seniorPlus: 14.5,
    specialist: 15.5,
  },
  {
    level: "7*",
    beginner: 10.5,
    advanced: 11,
    experienced: 12,
    senior: 13.5,
    seniorPlus: 15,
    specialist: 16,
  },
];
const translation = {
  מתחיל: "beginner",
  מתקדם: "advanced",
  מנוסה: "experienced",
  בכיר: "senior",
  "בכיר+": "seniorPlus",
  מומחה: "specialist",
};
export const ranks = [
  { rank: 0, label: "מתחיל" },
  { rank: 1, label: "מתקדם" },
  { rank: 2, label: "מנוסה" },
  { rank: 3, label: "בכיר" },
  { rank: 4, label: "בכיר+" },
  { rank: 5, label: "מומחה" },
];
export const dataToCalc = {
  seniority,
  salaryBase,
  levelPerTime,
  levelPerCompletion,
  hoursPerDegree,
  addiitionToShekelLaw,
  managementLevels,
  ranks,
  translation,
};
